module.exports = __webpack_public_path__ + "2acb60f2/img/rename-icon.de4e673d.svg";